import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

import { RadioButtonStyleProps } from "./RadioButton.constants";

export const StyledOuterContainer = styled.div<RadioButtonStyleProps>`
  display: flex;
  align-items: flex-start;

  margin-top: -6px;
  margin-bottom: -6px;

  ${({ disabled }) => disabled && `pointer-events: none;`};

  @media ${MEDIA_QUERIES.MOBILE} {
    width: 100%;
  }
`;

export const GroupTitle = styled.div`
  display: flex;

  font-size: 18px;
  letter-spacing: 0.23px;
  font-weight: 500;

  @media ${MEDIA_QUERIES.MOBILE} {
    width: 100%;
  }
`;

export const RadioField = styled.div<{ isSelected: boolean }>`
  display: flex;

  outline: none;

  cursor: pointer;

  border: 1px solid ${DIGIPOSTHEME.colors.whiteGrey};

  :focus {
    ${({ isSelected }) =>
      !isSelected && `border: 1px solid ${DIGIPOSTHEME.colors.darkGrey};`};
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    margin: 0;
  }
`;
export const RadioContainer = styled.div<RadioButtonStyleProps>`
  display: flex;
  ${({ direction }) => direction && `flex-direction:${direction}`};

  outline: none;

  & > :last-child > :last-child {
    margin: 1px 0 0 4px;
  }
`;

export const StyledLabel = styled.div`
  display: flex;
  align-items: center;
  margin: 1px 64px 0 4px;

  color: ${DIGIPOSTHEME.colors.secondaryGrayPrimary};
  font-family: "Campton";
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;

  pointer-events: none;

  @media ${MEDIA_QUERIES.MOBILE} {
    font-size: 12px;
  }
`;
